import * as actionTypes from "./actiontypes"
import states from "./states"

const model_accuracy_details = (state = states.model_accuracy_details, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_MODEL_ACCURACY_STATE:
            return {
                ...state,
                ...action.payload
            }

        default:
            return state
    }
}

export default model_accuracy_details



// WEBPACK FOOTER //
// ./src/data/redux/model_accuracy_details/reducers.js